/**
 * Command program-name extraction (ticket 3525, upstream pin e3e7cc3f, MIT),
 * ported from upstream `packages/client-runtime/src/work-log/commandLabel.ts`
 * and split across workLogCommandTokens/Split/Programs/Wrappers/Parse to hold
 * the file under the size cap. Byte-faithful: the ported timeline label specs
 * pin this behavior by name. The parser modules are mutually recursive
 * upstream; here they call through workLogCommandDispatcher, which this
 * module wires to the real implementation at load.
 *
 * @module workLogCommandLabels
 */

import { MAX_COMMAND_SEGMENTS, type CommandProgramContext } from "./workLogCommandTokens";
import { registerCommandProgramNameInternal } from "./workLogCommandDispatcher";
import { parseCommandProgramName } from "./workLogCommandParse";
import { literalCommandAliasProgramName } from "./workLogCommandWrappers";
import { powerShellCallOperatorProgramName } from "./workLogCommandPrograms";

function commandProgramNameInternal(
  command: string,
  depth: number,
  context: CommandProgramContext,
  segmentsRemaining: number = MAX_COMMAND_SEGMENTS,
): string | null {
  if (segmentsRemaining <= 0) return null;
  const calledProgram = powerShellCallOperatorProgramName(command);
  if (calledProgram !== undefined) return calledProgram;
  return (
    parseCommandProgramName(command, depth, context, segmentsRemaining) ??
    (context === "shell" ? literalCommandAliasProgramName(command) : null)
  );
}

registerCommandProgramNameInternal(commandProgramNameInternal);

export function commandProgramName(command: string, depth = 0): string | null {
  return commandProgramNameInternal(command, depth, "shell", MAX_COMMAND_SEGMENTS);
}
